import { Show, SimpleShowLayout, TextField, BooleanField, FunctionField } from "react-admin";

export const MemberShow = (props) => {
	return (
		<Show {...props} title="Member">
			<SimpleShowLayout>
				<TextField source="firstName" />
				<TextField source="gender" />
				<TextField source="timeZone" />
				<TextField source="verified" />
				<TextField source="email" />
				<TextField source="country" label="Country" />
				<FunctionField
                    label="Consented to the privacy policy"
                    render={(record) => {
                        return record && record.consented ? record.consented : "X";
                    }}
                />
				<TextField source="phoneNumber" />
				<TextField source="method" />
				<TextField source="subscriptionType" />
				<TextField source="revokeDate" />
				<TextField source="validUntil" />
				<BooleanField source="isDeleted" />
			</SimpleShowLayout>
		</Show>
	);
};
